import { ProductState } from './State';

const initialState: ProductState = {
    estimationProducts: [],
    estimationProductsCursors: [],
    estimationProductCursorIndex: 0,
    orderProducts: [],
    orderProductsCursors: [],
    orderProductsCursorIndex: 0,
    brand: [],
    collaboration: [],
    season: [],
    type: [],
    category: [],
    channels: [],
    productsLoader: false
};

export default initialState;



// WEBPACK FOOTER //
// ./src/application/products/initialState.ts